import { useContext } from 'react';
import { PortalContext } from '@alfalab/core-components-shared/esm';
import { getDefaultPortalContainer } from '../utils.js';

var usePortalContainer = function () {
    var getContextPortalContainer = useContext(PortalContext);
    if (getContextPortalContainer()) {
        return getContextPortalContainer;
    }
    return getDefaultPortalContainer;
};

export { usePortalContainer };
